export default __webpack_public_path__ + "static/media/school_kid.0f3cb404.png";